export const smiley = [
    '1.svg',     '10.svg',    '11.svg',    '12.svg',
    '13.svg',    '14.svg',    '15.svg',    '16.svg',
    '17.svg',    '18.svg',    '19.svg',    '1f600.svg',
    '1f608.svg', '1f60a.svg', '1f60b.svg', '1f60c.svg',
    '1f60d.svg', '1f60e.svg', '1f60f.svg', '1f618.svg',
    '1f61a.svg', '1f61b.svg', '1f61c.svg', '1f61d.svg',
    '1f61e.svg', '1f61f.svg', '1f621.svg', '1f624.svg',
    '1f62a.svg', '1f62b.svg', '1f62c.svg', '1f62d.svg',
    '1f62e.svg', '1f62f.svg', '1f631.svg', '1f644.svg',
    '1f648.svg', '1f649.svg', '1f64a.svg', '2.svg',
    '20.svg',    '21.svg',    '22.svg',    '23.svg',
    '24.svg',    '25.svg',    '26.svg',    '27.svg',
    '28.svg',    '29.svg',    '3.svg',     '30.svg',
    '4.svg',     '5.svg',     '6.svg',     '7.svg',
    '8.svg',     '9.svg',     'e001.svg'
];


